/**
 * Postedición automática de fotos (spec 011-postedicion-fotos, US2)
 *
 * Conmutador «Mejora automática» y botón «Ver original» bajo cada foto que ya
 * tiene versión editada. El vídeo usa la editada salvo que el gerente la
 * desactive; la recortada sin editar se conserva siempre.
 */

import { Eye } from 'lucide-react';
import { Switch } from '@/components/ui/switch';

interface PhotoEnhancementControlsProps {
  enabled: boolean;
  saving?: boolean;
  canEdit: boolean;
  onToggle: (enabled: boolean) => void;
  onCompare: (showOriginal: boolean) => void;
}

export function PhotoEnhancementControls({ enabled, saving = false, canEdit, onToggle, onCompare }: PhotoEnhancementControlsProps) {
  const hold = (value: boolean) => () => onCompare(value);

  return (
    <div className="mt-2 space-y-1" data-testid="photo-enhancement">
      <div className="flex items-center justify-between gap-2">
        {canEdit ? (
          <label className="flex min-h-11 cursor-pointer items-center gap-2 text-sm font-light text-[#1e1e1e]">
            <Switch checked={enabled} disabled={saving} onCheckedChange={onToggle} aria-label="Mejora automática" />
            Mejora automática
          </label>
        ) : (
          <span className="text-sm font-light text-[#5f5d5b]">{enabled ? 'Mejora automática' : 'Sin mejora automática'}</span>
        )}
        <button
          type="button"
          className="inline-flex min-h-11 select-none items-center gap-1 px-1 text-xs font-light text-[#5f5d5b] underline underline-offset-4"
          onPointerDown={hold(true)}
          onPointerUp={hold(false)}
          onPointerLeave={hold(false)}
          onPointerCancel={hold(false)}
          onKeyDown={(e) => (e.key === ' ' || e.key === 'Enter') && onCompare(true)}
          onKeyUp={hold(false)}
          onContextMenu={(e) => e.preventDefault()}
        >
          <Eye className="h-3.5 w-3.5" aria-hidden="true" />
          Ver original
        </button>
      </div>
      {canEdit && <p className="text-xs font-light leading-snug text-[#9d9c9c]">Ajusta la luz y el color de la foto. No cambia el plato.</p>}
    </div>
  );
}
